import { z } from '@repo/schema'
import { GetHistoryCategorySchema } from '@repo/schema/history'

// The input and query params every `GET /<entity>/:id/history` list takes.
export const historyListInputSchema = z.object({
  category: GetHistoryCategorySchema.optional(),
  perPage: z.number().int().min(1).max(50).optional(),
  search: z.string().max(100).optional(),
  userId: z.number().int().optional(),
})

export const historyListParams = (input: z.infer<typeof historyListInputSchema>, page: number) => ({
  category: input.category,
  page,
  per_page: input.perPage,
  search: input.search,
  user_id: input.userId,
})
